export const appleAppStoreDownloadURL = "https://apps.apple.com/mx/app/pagohoy/id6444390384"